import LogoIcon from './logo.svg'

function Logo({width = 50, alt = "default"}) {
  return <img src={LogoIcon} alt={alt} width={width}></img>;
}

export default Logo;